import React, { useEffect, useState } from "react";
import { Stack } from "@chakra-ui/react";
import ReusableDrawer from "components/Drawers/ReusableDrawer";
import GradientButton from "components/Buttons/GradientButton";
import ReusableInput from "components/Inputs/ReusableInput";
import ReusableModal from "components/Modals/ReusableModal";

const STATUS_OPTIONS = [
  { label: "Pending", value: "Pending" },
  { label: "Verified", value: "Verified" },
  { label: "Rejected", value: "Rejected" },
];

const ReviewPaymentProofDrawer = ({ isOpen, onClose, proof, onUpdateStatus }) => {
  const [status, setStatus] = useState(proof?.status || "Pending");
  const [isConfirmModalOpen, setConfirmModalOpen] = useState(false);

  useEffect(() => {
    if (proof) {
      setStatus(proof.status || "Pending");
    }
  }, [proof]);

  const handleChange = (e) => {
   
    setStatus(e.target.value);
  };

  const handleSubmit = () => {
    setConfirmModalOpen(true);
  };

  const handleConfirmUpdate = () => {
    if (!proof?.payment_id) {
      alert("Missing payment_id, cannot update status");
      return;
    }
    onUpdateStatus(proof.payment_id, status);

    setConfirmModalOpen(false);
    onClose();
  };

  return (
    <>
      <ReusableDrawer
        isOpen={isOpen}
        onClose={onClose}
        headerContent={<h2>Review Payment Proof</h2>}
        bodyContent={
          <Stack spacing={4}>
            <ReusableInput
              label="Uploaded At"
              value={proof?.uploaded_at ? new Date(proof.uploaded_at).toLocaleString() : "N/A"}
              isDisabled
            />
            <ReusableInput
              label="Status"
              name="status"
              type="select"
              value={status}
              onChange={handleChange}
              options={STATUS_OPTIONS}
            />
          </Stack>
        }
        footerContent={
          <Stack direction="row" spacing={4} justifyContent="flex-end">
            <GradientButton onClick={onClose} width="100px" height="40px">
              Cancel
            </GradientButton>
            <GradientButton onClick={handleSubmit} width="100px" height="40px">
              Update
            </GradientButton>
          </Stack>
        }
      />

      <ReusableModal
        isOpen={isConfirmModalOpen}
        onClose={() => setConfirmModalOpen(false)}
        onConfirm={handleConfirmUpdate}
        title="Confirm Status Update"
        bodyMessage={
          <div>
            Are you sure you want to update the status to "<strong>{status}</strong>"?
          </div>
        }
        confirmLabel="Update"
        cancelLabel="Cancel"
      />
    </>
  );
};

export default ReviewPaymentProofDrawer;
